import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const IraCompanionActionsCell = (props: {
  onDelete: () => void;
  planAssociationsCount: number;
  planName: string;
}) => {
  const [isDeleteOpen, toggleDeleteOpen] = useToggle();

  const onConfirmDelete = () => {
    toggleDeleteOpen();
    props.onDelete();
  };

  return (
    <>
      <ActionMenu
        actions={[
          {
            content: 'Delete',
            destructive: true,
            disabled: !!props.planAssociationsCount,
            onSelect: toggleDeleteOpen,
            tooltip: props.planAssociationsCount
              ? 'Remove the plan associations before deleting'
              : undefined
          }
        ]}
        trigger={
          <IconButton data-testid={`actions-${camelCase(props.planName)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmationText='DELETE'
        confirmColor='error'
        confirmText='Delete'
        data-testid='deleteIraCompanion'
        isOpen={isDeleteOpen}
        message={`This will permanently delete the IRA companion for "${props.planName}". This action is irreversible.`}
        onCancel={toggleDeleteOpen}
        onConfirm={onConfirmDelete}
        title='Delete IRA Companion'
      />
    </>
  );
};
